export const PRIVACY_POLICY_DOC_URL =
  'https://thanx.s3.us-east-1.amazonaws.com/uploads/doc/privacy_policy.docx'
export const PRIVACY_POLICY_DOC_FILENAME = 'privacy_policy.docx'
export const TERMS_OF_SERVICE_DOC_URL =
  'https://thanx.s3.us-east-1.amazonaws.com/uploads/doc/terms_of_service.docx'
export const TERMS_OF_SERVICE_DOC_FILENAME = 'terms_of_service.docx'
export const CCPA_DOC_URL =
  'https://thanx.s3.us-east-1.amazonaws.com/uploads/doc/opt_out_template.docx'
export const CCPA_DOC_FILENAME = 'opt_out_template.docx'

// Public legal route for the RecoveryAI Terms of Service page. Lives here (not on
// the page component) so pure-constant modules can reference it without importing
// the React page — also keep this in sync with isLegalPage() in utilities/pages.ts.
export const RECOVERY_AI_TERMS_PATH = '/recovery-ai-terms'
